import AttributeRepository from "@/repositories/vns/AttributeRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'attribute',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await AttributeRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.attributes)
                if (response.data.data.meta && Object.keys(response.data.data.meta).length > 0){
                    commit('setPagination', response.data.data.meta)
                }
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await AttributeRepository.search(params).then(response => {
                if (response.data.data.attributes.length > 0){
                    const array = response.data.data.attributes
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        },
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await AttributeRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.attribute)
            })
            commit('setLoading', false)
        }
    }
}
